var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleHealthCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -973.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Health-care",
    transform: "translate(2352.000000, 973.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8636,16.0293503 L14.5396,24.5092975 L17.0566,17.8589938 L17.6846,19.5377702 L26.9636,19.5377702 L17.0876,29.5466392 C16.4796,30.1511203 15.4996,30.1511203 14.9046,29.5466392 L14.9046,29.5466392 L5.0176,19.5377702 L6.9776,19.5377702 L7.7396,18.076688 L9.9106,22.4771477 L11.8636,16.0293503 Z M24,3 C28.42,3 32,6.62486101 32,11.1002481 C32,13.2063126 30.713,15.2516252 30.713,15.2516252 C30.359,15.8064922 29.552,16.8028227 28.925,17.5126069 L28.925,17.5126069 L19.065,17.5126069 L17.068,12.1674558 L14.71,18.3985716 L11.824,9.25035392 L9.465,17.0407675 L7.79,13.6447385 L5.772,17.5126069 L3.027,17.5126069 C2.435,16.8858503 1.658,15.8601563 1.225,15.1685977 C1.225,15.1685977 0,13.1759366 0,11.1002481 C0,6.62486101 3.58,3 7.995,3 C11.844,3 15.235,5.7459841 16,9.41438394 C16.772,5.75813447 20.157,3 24,3 Z",
    id: 42
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleHealthCare);
export default __webpack_public_path__ + "static/media/life-and-people-health-care.b07af028.svg";
export { ForwardRef as ReactComponent };